import toggleBoolStringAttribute from 'views/utils/toggleBoolStringAttribute'
import { ARIA_HIDDEN } from 'views/assets/scripts/consts'

export function notepadHeartToggle(
  state: boolean,
  { heartFilledIcon, heartIcon }: any
): void {
  toggleBoolStringAttribute(heartFilledIcon, ARIA_HIDDEN, state)
  toggleBoolStringAttribute(heartIcon, ARIA_HIDDEN, !state)
}

export const handleNotepadError = (tooltipTextContainer: HTMLElement): void => {
  // eslint-disable-next-line no-param-reassign
  tooltipTextContainer.textContent =
    'Etwas ist schief gelaufen, bitte laden Sie Seite neu'
  toggleBoolStringAttribute(tooltipTextContainer, ARIA_HIDDEN, true)
}
